import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import classNames from "classnames";
import { Grid, ButtonBase } from '@material-ui/core';
import Container from '../../components/Container'
import Typo from '../../components/CustomTypo';
import Button from '../../components/ButtonCustom';
import { WalletIcon, OrderHeaderIcon, DeliveryIcon, PickUpIcon, ReOrderIconNew, ReOrderIconNew1 } from '../../components/icons'
import CustomizedCircularProgress from '../../components/CircularProgress'
import { formatDateToDDMMYYYYFrEpoch } from '../../utils/util';
import { LinkCTA } from '../../components/Link';
import DrawerCustom from '../../components/DrawerCustom';
import OrderStoresController from './OrderStoresController'
import MenuItemsController from './MenuItemsController'
import Addresses from '../addresses/Addresses'
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';
import ModalAlert from '../../components/ModalAlert';
import ModalConfirm from '../../components/ModalConfirm'
import { getAppCfg } from '../../utils/common';
import t from '../../utils/translateUtil';
import theme from '../../theme.css';

function OrderMainPageView(props) {
    const { classes, t, delivery_address, pick_up_store, currency, onShowDetailOrder, onShowDetailOffer, isShowOffer } = props;
    return (
        <Container showLoading={props.showLoading}>
            <Grid xs={12} item container direction="row" alignContent='flex-start'>
                <Grid xs={12} sm={12} md={12} lg={7} item className={classes.card}>
                    <Grid className={classes.cardContent}>
                        <Grid xs={12} item container direction="row" alignItems='center'>
                            <Typo mg_right_sm variant='h3' color="onPrimary">{t('order_title')}</Typo>
                            <OrderHeaderIcon />
                        </Grid>
                        <Typo mg_top_sm variant='h6' color="onPrimary">{t('order_method')}</Typo>
                        <OrderMethod
                            classes={classes} t={t}
                            showStores={props.showStores}
                            handleShowRightContent={props.handleShowRightContent}
                            onInitOrderPickUp={props.onInitOrderPickUp}
                            onInitOrderDelivery={props.onInitOrderDelivery}
                            delivery_address={delivery_address}
                            pick_up_store={pick_up_store} 
                            onInitOrderDirectSale={props.onInitOrderDirectSale}/>
                    </Grid>
                    {isShowOffer && <Grid className={classes.cardContent}>
                        <Typo variant='h3' color="onPrimary">{t('order_my_orders')}</Typo>
                        <MyOrders classes={classes} t={t} 
                        currency={currency} 
                        my_orders={props.my_orders} 
                        showLoadingMyOrders={props.showLoadingMyOrders} 
                        onShowDetailOrder={onShowDetailOrder} 
                        onReorder={props.onReorder}/>
                    </Grid>}
                </Grid>
                {isShowOffer && <Grid xs={12} sm={12} md={12} lg={5} item>
                    <Grid xs={12} item className={classes.card}>
                        <Grid className={classes.cardContent}>
                            <Typo variant='h3' color="onPrimary">{t('order_promotion')}</Typo>
                            <Promotions classes={classes} t={t} showLoadingOffers={props.showLoadingOffers} offers={props.promotions} onShowDetailOffer={onShowDetailOffer} />
                        </Grid>
                    </Grid>
                </Grid>}
                {!isShowOffer && <Grid xs={12} sm={12} md={12} lg={5} item>
                    <Grid xs={12} item className={classes.card}>
                        <Grid className={classes.cardContent}>
                            <Typo variant='h3' color="onPrimary">{t('order_my_orders')}</Typo>
                            <MyOrders classes={classes} t={t} 
                                currency={currency} 
                                my_orders={props.my_orders} 
                                showLoadingMyOrders={props.showLoadingMyOrders} 
                                onShowDetailOrder={onShowDetailOrder}
                                onReorder={props.onReorder}  />
                        </Grid>
                    </Grid>
                </Grid>}
            </Grid>
            {props.showStores && <OrderStoresController open={props.showStores} onClose={() => props.handleShowRightContent('showStores')} />}
            {props.showAddresses && <Addresses from='order' open={props.showAddresses} onCloseItem={() => props.handleShowRightContent('showAddresses')} onGoBackAfterSetCurrentAddress={props.onGoBackAfterSetCurrentAddress} onInitReOrderDelivery={props.onInitReOrderDelivery} reOrder={props.reOrder}/>}
            {props.showMenuItems && <MenuItemsController open={props.showMenuItems} onClose={() => props.handleShowRightContent('showMenuItems')} refreshMyOrders={props.refreshMyOrders} reOrder={props.reOrder}/>}
            {props.message && <ModalAlert
                open={props.message.show}
                onClose={props.showMessage}
                message={props.message.content}
            />}
            {props.confirm && <ModalConfirm
                open={props.confirm.show}
                onClose={props.showConfirm}
                message={props.confirm.content}
                confirm={t('add_a_card')}
                onAction={props.onShowAddCardForm}
            />}
        </Container >
    );
}
function OrderMethod(props) {
    const { classes, t, delivery_address, pick_up_store, showStores } = props;
    var pickupStoreAddress = pick_up_store && pick_up_store.address ? " - " + pick_up_store.address.address_line_1 : "";
    var pickupStoreName = pick_up_store && pick_up_store.name ? pick_up_store.name : t('order_select_store');
    var apcfg = getAppCfg()
    var app_config = apcfg && apcfg.features && apcfg.features.ordering_details ? apcfg.features.ordering_details : {};
    //console.log('app_config=== ',app_config)
    // app_config.ordering_direct_sale = true;
    return (
        <Grid item xs={12} direction="row" container className={classes.marginTop}>
            {app_config.ordering_delivery && <Grid item xs={12} sm={12} md={12} lg={app_config.ordering_pickup ? 6 : 12} xl={app_config.ordering_pickup ? 6 : 12} className={classNames(classes.boxContainer, classes.left)}>
                <Grid xs={12} item className={classes.boxContent} onClick={props.onInitOrderDelivery}>
                    <Grid xs={12} item>
                        <Typo variant='h5' >{t('delivery')}</Typo>
                    </Grid>
                    <Grid xs={12} item>
                        <Typo mg_top_sm variant='body1' color='primary' >{delivery_address ? delivery_address.address_line_1 : "No Address"}</Typo>
                    </Grid>
                </Grid>
                <Grid item className={classes.rightContent}>
                    <LinkCTA onClick={() => props.handleShowRightContent('showAddresses')} color="primary">{t('order_select_address')}</LinkCTA>
                </Grid>
                <Grid item container justify='center' alignItems='center' className={classes.circle}>
                    <DeliveryIcon />
                </Grid>
            </Grid>}

            {app_config.ordering_pickup && <Grid item xs={12} sm={12} md={12} lg={app_config.ordering_delivery ? 6 : 12} xl={app_config.ordering_delivery ? 6 : 12} className={classNames(classes.boxContainer, classes.right)}>
                <Grid xs={12} item className={classes.boxContent} onClick={() => props.onInitOrderPickUp('PICK_UP')}>
                    <Grid xs={12} item>
                        <Typo variant='h5' >{t('pickup')}</Typo>
                    </Grid>
                    {/* <Grid xs={12} item>
                        <Typo mg_top_sm variant='body1' color='primary' >{pickupStoreName}{pickupStoreAddress}</Typo>
                    </Grid> */}
                </Grid>
                {/* <Grid item className={classes.rightContent}>
                    <LinkCTA onClick={() => props.handleShowRightContent('showStores')} color="primary">{t('order_select_store')}</LinkCTA>
                </Grid> */}
                <Grid item container justify='center' alignItems='center' className={classes.circle}>
                    <PickUpIcon />
                </Grid>
            </Grid>}

            {app_config.ordering_direct_sale && <Grid item xs={12} sm={12} md={12} lg={app_config.ordering_direct_sale ? 6 : 12} xl={app_config.ordering_direct_sale ? 6 : 12} className={classNames(classes.boxContainer, classes.left)}>
                <Grid xs={12} item className={classes.boxContent} onClick={() => props.onInitOrderDirectSale('DIRECT_SALE')}>
                    <Grid xs={12} item>
                        <Typo variant='h5' >Add Service</Typo>
                    </Grid>
                </Grid>
                <Grid item container justify='center' alignItems='center' className={classes.circle}>
                    <PickUpIcon />
                </Grid>
            </Grid>}
        </Grid>
    )
}
function Products(props) {
    var strProduct = ""
    props.products.forEach(element => {
        strProduct = strProduct + element.quantity + "x " + element.product.name + ", ";
    });
    if (strProduct) {
        strProduct = strProduct.substr(0, strProduct.length - 2);
    }
    return (
        <Typo mg_top_xs variant='body1'>{strProduct}</Typo>
    )
}
function MyOrders(props) {
    const { classes, t, showLoadingMyOrders, my_orders, currency, onShowDetailOrder } = props;
//    console.log("my_orders:", my_orders)
    return (
        <Grid item xs={12} direction="row" container className={classes.marginTop}>
            {showLoadingMyOrders && <CustomizedCircularProgress />}
            {my_orders.map((item, index) =>
                <Grid item xs={12} key={index} className={classes.boxItemContainer}>
                <Grid item xs={12} key = {index} container className={classes.boxItemContent} onClick={() => onShowDetailOrder(item)}>
                    <Grid xs={12} item container alignItems='center'>
                        {item.fulfilled_by&&<Typo variant='subtitle2'>{item.fulfilled_by.name}</Typo>}
                    </Grid>
                    <Grid xs={12} item container alignItems='center'>
                        <Grid xs={8} item container justify='flex-start'>
                            {item.submitted_date && <Typo variant='body1' color='secondary' >{formatDateToDDMMYYYYFrEpoch(item.submitted_date)}</Typo>}
                            </Grid> 
                        <Grid xs={4} item container direction='row' alignItems='center' justify='flex-end'>
                            <Button className={classes.status} size="xs" color={"success"}>{dataUtil.getLCSName(item.life_cycle_state)}</Button>
                            {/* { item.supply_method && <Typo variant="body2" mg_left_sm className={classes.supply_method}>{getSupplyMethod(item.supply_method)}</Typo>} */}
                        </Grid>
                    </Grid>
                    <Grid xs={12} item container alignItems='center'>
                        <Typo mg_right_sm mg_top_sm variant='subtitle1'>{currency}{item.total_cost.toFixed(2)}</Typo>
                    </Grid>
                    {/* <Products products={item.order_items} /> */}
                </Grid>
                {item.supply_method != 'DIRECT_SALE' && <Grid item container justify='flex-end' onClick={()=>props.onReorder(item)} className={classes.reorder}>
                    <Typo variant='body1' color='primary' mg_right_sm>
                        <ReOrderIconNew1 className={classes.reorder_icon}/>
                    </Typo>
                </Grid>}
                </Grid>
            )}
        </Grid>
    )
}
function PromotionImage(props) {
    var classes = props.classes;
    var imageObject = props.image;
    if (imageObject) {
        return <img className={classes.image} src={imageObject.url} />
    } else {
        return (
            <Grid item className={classes.image}>

            </Grid>)
    }
}
function Promotions(props) {
    const { classes, offers, showLoadingOffers, onShowDetailOffer } = props;
    //console.log(' offers=====',offers)
    return (
        <Grid item xs={12} direction="row" container className={classes.marginTop}>
            {showLoadingOffers && <CustomizedCircularProgress />}
            {offers.map((item, index) =>
                <Grid xs={12} item key={index} direction='row' container className={classes.boxItemContentNoPadding} onClick={() => onShowDetailOffer(item)}>
                    <PromotionImage image={dataUtil.getImageByUsageTypePortal(item.creatives, usage_type.offer_order)} classes={classes} />
                    <Grid item xs={6} sm={7} md={8}>
                        {/* <Typo mg_top_xl variant='subtitle1' >{item.owned_by.name}</Typo> */}
                        <Typo mg_top_md variant='subtitle1' color='primary' >{item.name}</Typo>
                    </Grid>
                </Grid>
            )}
        </Grid>
    )
}
function getSupplyMethod(method){
    if(method == 'PICK_UP'){
        return t('pickup');
    }else if(method == 'DELIVERY'){
        return t('delivery');
    }else if(method == 'DIRECT_SALE'){
        return t('direct_sale');
    }
}
const styles = theme => ({
    card: {
        padding: theme.spacing(3),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1),
        },
    },
    cardContent: {
        backgroundColor: theme.palette.background.card,
        borderRadius: theme.shape.borderRadius2x,
        padding: theme.spacing(5),
        marginTop: theme.spacing(4),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
            marginTop: theme.spacing(2),
        },
    },
    orderBox: {
        padding: theme.spacing(4),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        borderRadius: theme.spacing(4),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        marginTop: theme.spacing(8),
    },
    boxContainer: {
        position: 'relative',
        paddingTop: theme.spacing(5),
        paddingBottom: theme.spacing(5),
        [theme.breakpoints.down('xs')]: {
            paddingBottom: theme.spacing(2),
        },
    },
    left: {
        paddingRight: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            paddingRight: 0,
        },
    },
    right: {
        paddingLeft: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            paddingLeft: 0,
        },
    },
    boxContent: {
        cursor: "pointer",
        padding: theme.spacing(6, 4, 4, 4),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        height: 120
    },
    boxItemContainer:{
        position: 'relative'
    },
    boxItemContent: {
        padding: theme.spacing(2, 4, 4, 4),
        marginTop: theme.spacing(1.5),
        marginBottom: theme.spacing(1.5),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        cursor: 'pointer'
    },
    boxItemContentNoPadding: {
        marginTop: theme.spacing(1.5),
        marginBottom: theme.spacing(1.5),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(2),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        height: 100,
        overflow: 'hidden',
        cursor: 'pointer'
    },
    circle: {
        width: theme.spacing(10),
        height: theme.spacing(10),
        borderRadius: theme.spacing(5),
        boxShadow: ' -1px 2px 14px -5px rgba(0,0,0,0.75)',
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.primary.main,
        position: 'absolute',
        top: 0,
        left: theme.spacing(10),
        textAlign: 'center',
    },
    rightContent: {
        position: 'absolute',
        top: theme.spacing(8),
        right: theme.spacing(8)
    },
    marginTop: {
        marginTop: theme.spacing(4)
    },
    image: {
        width: 100,
        height: 100,
        objectFit: 'cover',
        borderTopLeftRadius: theme.spacing(2),
        borderBottomLeftRadius: theme.spacing(2),
        marginRight: theme.spacing(3),
    },
    reorder:{
        position:'absolute',
        zIndex: 999, 
        top: theme.spacing(4), 
        right: theme.spacing(4), 
        cursor: 'pointer'
    },
    supply_method: {
        color: theme.palette.button.primary.backgroundColor,
    },
    reorder_icon: {
        fill: theme.palette.button.primary.backgroundColor,
    }
});
export default withStyles(styles)(withTranslation()(OrderMainPageView));